
const RecordingModel = {
    conversation_id: '',
    recordings: []

};

export default RecordingModel;